import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClick: '&?'
    },
    template: `
        <div class="close-icon" ng-click="vm.closeModal($event)"></div>
        <style>
            learn-modal-topbar-close {
                display: contents;
            }
        </style>
    `
})
export default class {
    closeModal ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        window.parent.postMessage('action:closeMaterialDialog', '*');
        if (this.onClick) {
            this.onClick();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/learnModal/topbar/close/index.js